import { UNICODE } from '@hcr/ui'
import { flow } from '@hcr/utils'

import { createActivityHistoryValidity } from './createActivityHistoryValidity'

export const createActivityHistoryValidityString = flow(
  createActivityHistoryValidity,
  ({ date, time }) => `${date} ${UNICODE.middleDot} ${time}`
)
